import {
  Dispatch,
  isRejectedWithValue,
  Middleware,
  MiddlewareAPI
} from '@reduxjs/toolkit';
import { serverApi } from "../../api/serverApi";
import { ErrorType } from "../../types/sharedTypes";
import { showErrorModal } from "../slices/mainSlice";
import { RootState } from "../index";
import i18n from "../../i18n";

const loginUrl = process.env.REACT_APP_LOGIN_URL as string;

const apiMiddleware: Middleware = (store: MiddlewareAPI<Dispatch, RootState>) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const payload = action.payload as ErrorType;
    if (payload.status === 401) {
      window.location.href = `${loginUrl}/#/login`;
    }
    if (payload.status === 403) {
      store.dispatch(showErrorModal({
        title: i18n.t("common.accessDenied"),
        description: i18n.t("common.accessDeniedDescription"),
        primaryText: i18n.t("common.ok")
      }));
      return next(action);
    }
    store.dispatch(showErrorModal({
      title: i18n.t("common.serverErrorOccured"),
      description: `${i18n.t("common.status")}: ${payload.status} ${payload.statusText}
                           ${i18n.t("common.errorMessage")}: ${payload.message}`,
      primaryText: i18n.t("common.ok")
    }));
  }
  return next(action);
};

export const middleware = [serverApi.middleware, apiMiddleware];